import React, { useEffect } from 'react';

const APIErrorPage = () => {
  return(
    <div className='wrong_page_container center centerWrongPage'>
    <span className='title'>The service is temporarily unavailable</span>
    <p>
    An unforeseen error has occurred.  Please try again later.  If the error persists, please contact customer service.
    </p>
    </div>
  );
}
export default APIErrorPage;